import React from 'react';

const HeaderInfo = ({
  title = "", 
  icon = "",
  iconColor = "",
  titleColor = "",
  backgroundColor = "#e3f2fd",
  dispatchSlNo = "",
  permanentSlNo = "",
  companyName = "",
  companyPlaceholder = "Enter Name of Company",
  onCompanyNameChange = null,
  showBlockCType = true,
  defaultBlockCType = "grossBlock",
  includeTableStyles = false,
  selectedBlockType = defaultBlockCType,
  onBlockTypeChange = null
}) => {
  return (
    <>
      {/* Table Styles - Only include when needed */}
      {includeTableStyles && (
        <style>
          {`
            .table th {
              background-color: #f8f9fa;
              border: 1px solid #dee2e6;
              font-weight: 600;
              font-size: 14px;
              text-align: center;
              vertical-align: middle;
              padding: 8px 4px;
            }
            .table td {
              border: 1px solid #dee2e6;
              padding: 6px 4px;
              font-size: 13px;
            }
            .table input {
              border: 1px solid #e0e0e0;
              background: white;
              width: 100%;
              text-align: center;
              font-size: 13px;
              border-radius: 6px;
              padding: 8px 12px;
              transition: all 0.3s ease;
            }
            .table input:focus {
              outline: none;
              border-color: #f75226;
              transform: translateY(-1px);
            }
            .table input:disabled {
              background-color: #f8f9fa;
              border-color: #dee2e6;
              color: #6c757d;
              cursor: not-allowed;
            }
            .table select {
              border: 1px solid #e0e0e0;
              background: white;
              width: 100%;
              text-align: center;
              font-size: 13px;
              border-radius: 6px;
              padding: 8px 12px;
              transition: all 0.3s ease;
              padding-right: 35px; /* Make space for the arrow */
            }
            .table select:focus {
              outline: none;
              border-color: #f75226;
              transform: translateY(-1px);
            }
            .status-field {
              background-color: #f8f9fa;
              border: 1px solid #dee2e6;
              padding: 6px 8px;
              font-size: 12px;
              text-align: center;
              min-width: 120px;
            }
          `}
        </style>
      )}

      {/* Header Section */}
      <div className="card mb-3">
        <div className="card-body pb-1" style={{ backgroundColor: backgroundColor, border: 'none' }}>
          <div className="row align-items-center">
            <div className="col-md-12">
            <h4 className="page_heading mb-3 pb-2 border-bottom">
                  ASI Schedule 2024-25 <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>CONFIDENTIAL <i className="fa fa-lock me-2" style={{ fontSize: '20px', color: '#1976d2' }}></i></span>
                </h4>
              <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                {/*  {icon && (
                  <i className={`${icon} me-2`} style={{ fontSize: '24px', color: iconColor }}></i>
                )}*/}
                {title && (
                  <h5 className="page_heading mb-0" style={{ color: titleColor, fontWeight: 'bold' }}>
                    {title}
                  </h5>
                )}
              </div>
              
              {showBlockCType && (
                <div className="block-c-type-section">
                  <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                    Block C Type:
                  </label>
                  <div className="d-flex gap-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="blockCType"
                        id="grossBlock"
                        value="grossBlock"
                        checked={selectedBlockType === "grossBlock"}
                        onChange={(e) => onBlockTypeChange && onBlockTypeChange(e.target.value)}
                        style={{ cursor: 'pointer' }}
                      />
                      <label className="form-check-label" htmlFor="grossBlock" style={{ cursor: 'pointer', fontSize: '14px' }}>
                        Gross Block
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="blockCType"
                        id="netBlock"
                        value="netBlock"
                        checked={selectedBlockType === "netBlock"}
                        onChange={(e) => onBlockTypeChange && onBlockTypeChange(e.target.value)}
                        style={{ cursor: 'pointer' }}
                      />
                      <label className="form-check-label" htmlFor="netBlock" style={{ cursor: 'pointer', fontSize: '14px' }}>
                        Net Block
                      </label>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                    DSL No.:
                  </label>
                  <div>{dispatchSlNo}</div>
                  
                </div>
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                    PSL No.:
                  </label>
                  <div>{permanentSlNo}</div>
                  
                </div>
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                    Name of Company:
                  </label>
                  <div>{companyName}</div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          .page_heading {
            border-bottom: none;
          }
        `}
      </style>
    </>
  );
};

export default HeaderInfo;
